<mat-sidenav-container>
	<mat-sidenav #sidenav mode="side" opened>
		<div class="row sidenav-head">
			<div class="col-md-12 d-flex align-items-end">
				<img src="assets/img/shared/alamat.svg" alt="" class="alamat-logo">
				<div class="text">
					<p class="t-fs18 m-0">Alamatch</p>
					<p class="t-fs12 m-0">Admin Portal</p>
				</div>
			</div>
		</div>

		<mat-list class="mt-4">
			<mat-list-item class="pointer" 
				[ngClass]="{'nav-link-active': router.url == '/home/dashboard'}" 
				href="/home/dashboard" 
				routerLink="/home/dashboard">
				<a routerLinkActive="active" class="nav-link d-flex justify-content-between">
					<img src="assets/img/sidenav/dashboard.svg" alt="" class="nav-img">
					<p class="t-fs14 m-0 jakarta">Dashboard</p>
				</a>
			</mat-list-item>
			
			<mat-list-item class="pointer" 
				[ngClass]="{'nav-link-active': router.url == '/home/tournament' 
					|| router.url == '/home/season/leagues' 
					|| router.url == '/home/season/leagues/league-players' 
					|| router.url == '/home/season/leagues/league-games'
					|| router.url == '/home/season/leagues/tournament-bracket'
					|| router.url == '/home/season/leagues/league-scorers'}" 
				href="/home/tournament" 
				routerLink="/home/tournament">
				<a routerLinkActive="active" class="nav-link d-flex justify-content-between">
					<img src="assets/img/sidenav/tournament.svg" alt="" class="nav-img">
					<p class="t-fs14 m-0 jakarta">Tournament</p>
				</a>
			</mat-list-item>

			<mat-list-item class="pointer" 
				[ngClass]="{'nav-link-active': router.url == '/home/casual-game-list'}" 
				href="/home/casual-game-list" 
				routerLink="/home/casual-game-list">
				<a routerLinkActive="active" class="nav-link d-flex justify-content-between">
					<img src="assets/img/sidenav/players.svg" alt="" class="nav-img">
					<p class="t-fs14 m-0 jakarta">Casual Games</p>
				</a>
			</mat-list-item>

			<mat-list-item class="pointer" 
				[ngClass]="{'nav-link-active': router.url == '/home/players'}" 
				href="/home/players" 
				routerLink="/home/players">
				<a routerLinkActive="active" class="nav-link d-flex justify-content-between">
					<img src="assets/img/sidenav/players.svg" alt="" class="nav-img">
					<p class="t-fs14 m-0 jakarta">Players</p>
				</a>
			</mat-list-item>

			<mat-list-item class="pointer" 
				[ngClass]="{'nav-link-active': router.url == '/home/scorer'}" 
				href="/home/scorer" 
				routerLink="/home/scorer">
				<a routerLinkActive="active" class="nav-link d-flex justify-content-between">
					<img src="assets/img/sidenav/scorer.svg" alt="" class="nav-img">
					<p class="t-fs14 m-0 jakarta">Scorer</p>
				</a>
			</mat-list-item>

			<mat-list-item class="pointer" 
				[ngClass]="{'nav-link-active': router.url == '/home/analytics'}" 
				href="/home/analytics" 
				routerLink="/home/analytics">
				<a routerLinkActive="active" class="nav-link d-flex justify-content-between">
					<img src="assets/img/sidenav/analytics.svg" alt="" class="nav-img">
					<p class="t-fs14 m-0 jakarta">Analytics</p>
				</a>
			</mat-list-item>

			<mat-list-item class="pointer" 
				[ngClass]="{'nav-link-active': router.url == '/home/settings'}" 
				href="/home/settings" 
				routerLink="/home/settings">
				<a routerLinkActive="active" class="nav-link d-flex justify-content-between">
					<img src="assets/img/sidenav/settings.svg" alt="" class="nav-img">
					<p class="t-fs14 m-0 jakarta">Settings</p>
				</a>
			</mat-list-item>
		 </mat-list>

		 <div class="profile d-flex justify-content-center">
				<div class="bottom-container">
					<div class="row">
						<div class="col-md-12 d-flex justify-content-center">
							<div class="profile-container d-flex align-items-center">
								<div class="avatar"></div>
								<div class="name">
									<p class="t-fs14 m-0">{{ userProfile?.name }}</p>
									<p class="t-fs12 m-0">{{ userProfile?.username }}</p>
								</div>
							</div>
						</div>
					</div>
	
					<div class="row">
						<div class="col-md-12 d-flex justify-content-center">
							<button class="d-flex align-items-center" (click)="logout()">
								<img src="assets/img/sidenav/logout.svg" alt="" class="nav-img">
								<p class="t-fs14 m-0 jakarta">Logout</p>
							</button>
						</div>
					</div>
				</div>
		 </div>
	</mat-sidenav>
	<mat-sidenav-content>
		<!-- <mat-toolbar>
			<button mat-icon-button (click)="drawer.toggle()" class="example-icon" aria-label="Example icon-button with menu icon">
				<mat-icon>menu</mat-icon>
			</button>
		</mat-toolbar> -->

		<div class="container-fluid">
			<div class="row">
				<div class="col-md-12">
					<app-page-content></app-page-content>
				</div>
			</div>
		</div>
	</mat-sidenav-content>
</mat-sidenav-container>